import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Confirm, Dimmer, Grid, Loader } from 'semantic-ui-react';
import { productsActions } from '../../actions/products.actions';

class ProductsShowScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      submitted: false,
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    dispatch(productsActions.getById(match.params.id));
  }

  handleCancel = () => this.setState({ open: false });

  deleteShow = () => this.setState({ open: true });

  deleteById() {
    const { match, dispatch } = this.props;

    dispatch(productsActions.deleteById(match.params.id)).then(() =>
      this.props.history.push('/products'),
    );
  }

  editById() {
    const { match } = this.props;

    this.props.history.push(`/products/${match.params.id}/edit`);
  }

  render() {
    const { products, loading } = this.props;
    const { open } = this.state;

    if (!products)
      return (
        <Dimmer active>
          <Loader />
        </Dimmer>
      );

    return (
      <Fragment>
        <Confirm
          content="Deseja remover esse item?"
          open={open}
          onCancel={this.handleCancel}
          onConfirm={() => this.deleteById()}
        />
        <Grid className="header-page">
          <Grid.Column mobile={16} tablet={10} computer={10}>
            <h1>{products.name}</h1>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={6} computer={6} textAlign="right">
            <Button icon="edit outline" onClick={() => this.editById()} />
            <Button icon="trash alternate outline" onClick={this.deleteShow} />
          </Grid.Column>
        </Grid>
        <Loader active={loading} />
        <div className="container-inner">
          <h4>Fabricante: </h4>
          {products.provider ? products.provider.name : ''}
          <h4>Nome: </h4>
          {products.name}
          <h4>NCM: </h4>
          {products.ncm}
          <h4>SKU: </h4>
          {products.sku}
          <h4>Part Number: </h4>
          {products.part_number}
          <h4>Descrição: </h4>
          {products.description}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { products } = state;

  return {
    products: products.item,
    loading: products.loading || false,
  };
}

const connectedProductsShowScreen = connect(mapStateToProps)(ProductsShowScreen);
export { connectedProductsShowScreen as ProductsShowScreen };
